<div class="variant-section">
  <span class="f-12 _700 mb-4">Do you want to add technical(s) variant(s) to this Master ?</span>
  <div class="table-scroll-wrapper">
    <div
      #tableContainer
      class="table-container variants-table-container"
      [class.table-container--only-variant]="forVariant"
      (scroll)="handleScroll()">
      <table class="table table-bordered">
        <thead>
          <tr class="variants-header-row">
            <th class="variants-header-cell variants-header-title">Title</th>
            <th class="variants-header-cell variants-header-platform">Platform</th>
            @if (types.length > 0) {
              <th class="variants-header-cell variants-header-type">Type</th>
            }
            @if (focuses.length > 0) {
              <th class="variants-header-cell variants-header-focus">Focus</th>
            }
            @if (availableCategories.length > 0) {
              <th class="variants-header-cell variants-header-categories">Categories</th>
            }
            <th class="variants-header-cell variants-header-length">Length</th>
            <th class="variants-header-cell variants-header-format">Format</th>
            <th class="variants-header-cell variants-header-actions">Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (asset of tempAssets; track trackByAsset; let i = $index) {
            <tr class="variants-row">
              <td
                class="variants-cell variants-cell-title"
                [ngClass]="{ 'red-border': submitted && asset.detail === '' }">
                <input
                  [ngModel]="asset.detail"
                  (ngModelChange)="onTitleChange(asset, i, $event)"
                  class="input-no-border w-100 variants-input"
                  placeholder="Name it here..." />
              </td>

              <td
                class="variants-cell variants-cell-platform"
                [ngClass]="{ 'red-border': submitted && asset?.bets?.length === 0 }"
                [style.height]="`${(asset?.bets?.length > 1 ? 20 : 0) + asset?.bets?.length * 32}px`"
                [class.py-4]="asset?.bets?.length > 1">
                <div ngbDropdown #betsDropdown="ngbDropdown" class="dropdown-wrapper w-100">
                  <div class="custom-dropdown-container d-flex align-items-center" ngbDropdownToggle>
                    @if (asset?.bets?.length > 0) {
                      <div class="custom-dropdown-toggle custom-dropdown-toggle--bets">
                        @for (bet of asset?.bets; track bet) {
                          <div class="bet-item py-1">
                            <i class="mtm-icon mtm-icon-{{ bet?.toLowerCase() }} me-1 ms-2 variants-bet-icon"></i>
                            {{ bet }}
                          </div>
                        }
                      </div>
                    } @else {
                      <div class="custom-dropdown-toggle custom-dropdown-toggle--bets">-</div>
                    }
                    <div class="variants-dropdown-indicator">
                      <i class="fa fa-chevron-down variants-dropdown-indicator__icon"></i>
                    </div>
                  </div>

                  <div ngbDropdownMenu class="bets-dropdown-menu w-auto">
                    @for (bet of betsOptions; track bet) {
                      <label class="dropdown-item">
                        <input
                          type="checkbox"
                          [checked]="asset.bets?.includes(bet)"
                          (change)="onBetsChange(asset, i, bet)" />
                        <i class="mtm-icon mtm-icon-{{ bet?.toLowerCase() }} me-1 ms-2 variants-bet-icon"></i>
                        {{ bet }}
                      </label>
                    }
                  </div>
                </div>
              </td>

              @if (types.length > 0) {
                <td class="variants-cell variants-cell-type">
                  <div ngbDropdown #typesDropdown="ngbDropdown" class="dropdown-wrapper w-100">
                    <div class="custom-dropdown-container d-flex align-items-center" ngbDropdownToggle>
                      <span class="custom-dropdown-toggle">{{ asset.type || '-' }}</span>
                      <div class="variants-dropdown-indicator">
                        <i class="fa fa-chevron-down variants-dropdown-indicator__icon"></i>
                      </div>
                    </div>

                    <div ngbDropdownMenu class="length-dropdown-menu w-auto">
                      @for (type of types; track type) {
                        <button
                          type="button"
                          class="dropdown-item"
                          (click)="onTypeChange(asset, i, type); typesDropdown.close()">
                          {{ type }}
                        </button>
                      }
                    </div>
                  </div>
                </td>
              }

              @if (focuses.length > 0) {
                <td class="variants-cell variants-cell-focus">
                  <div ngbDropdown #focusDropdown="ngbDropdown" class="dropdown-wrapper w-100">
                    <div class="custom-dropdown-container d-flex align-items-center" ngbDropdownToggle>
                      <span class="custom-dropdown-toggle">{{ asset.focus || '-' }}</span>
                      <div class="variants-dropdown-indicator">
                        <i class="fa fa-chevron-down variants-dropdown-indicator__icon"></i>
                      </div>
                    </div>

                    <div ngbDropdownMenu class="length-dropdown-menu w-auto">
                      @for (focus of focuses; track focus) {
                        <button
                          type="button"
                          class="dropdown-item"
                          (click)="onFocusChange(asset, i, focus); focusDropdown.close()">
                          {{ focus }}
                        </button>
                      }
                    </div>
                  </div>
                </td>
              }

              @if (availableCategories.length > 0) {
                <td class="variants-cell variants-cell-categories">
                  <div ngbDropdown #categoryDropdown="ngbDropdown" class="dropdown-wrapper w-100">
                    <div class="custom-dropdown-container d-flex align-items-center" ngbDropdownToggle>
                      <span class="custom-dropdown-toggle">{{ asset.categories || '-' }}</span>
                      <div class="variants-dropdown-indicator">
                        <i class="fa fa-chevron-down variants-dropdown-indicator__icon"></i>
                      </div>
                    </div>

                    <div ngbDropdownMenu class="length-dropdown-menu w-auto">
                      @for (category of availableCategories; track category) {
                        <button
                          type="button"
                          class="dropdown-item"
                          (click)="onCategoryChange(asset, i, category); categoryDropdown.close()">
                          {{ category }}
                        </button>
                      }
                    </div>
                  </div>
                </td>
              }

              <td class="variants-cell variants-cell-length">
                <div ngbDropdown #lengthDropdown="ngbDropdown" class="dropdown-wrapper w-100">
                  <div class="custom-dropdown-container d-flex align-items-center" ngbDropdownToggle>
                    @if (asset?.length?.length) {
                      <span class="custom-dropdown-toggle">{{ asset.length }}</span>
                    } @else {
                      <span class="custom-dropdown-toggle">-</span>
                    }
                    <div class="variants-dropdown-indicator">
                      <i class="fa fa-chevron-down variants-dropdown-indicator__icon"></i>
                    </div>
                  </div>

                  <div ngbDropdownMenu class="length-dropdown-menu w-auto">
                    @for (length of lengthOptions; track length) {
                      <button
                        type="button"
                        class="dropdown-item"
                        (click)="onLengthChange(asset, i, length); lengthDropdown.close()">
                        {{ length }}
                      </button>
                    }
                  </div>
                </div>
              </td>

              <td class="variants-cell variants-cell-format">
                <div ngbDropdown #formatDropdown="ngbDropdown" class="dropdown-wrapper w-100">
                  <div class="custom-dropdown-container d-flex align-items-center" ngbDropdownToggle>
                    @if (asset?.format?.length) {
                      <span class="custom-dropdown-toggle" [innerHTML]="getFormatDisplay(asset.format[0])"></span>
                    } @else {
                      <span class="custom-dropdown-toggle">-</span>
                    }
                    <div class="variants-dropdown-indicator">
                      <i class="fa fa-chevron-down variants-dropdown-indicator__icon"></i>
                    </div>
                  </div>

                  <div ngbDropdownMenu class="format-dropdown-menu w-auto">
                    @for (format of formatOptions; track format) {
                      <button
                        type="button"
                        class="dropdown-item"
                        (click)="onFormatChange(asset, i, format); formatDropdown.close()">
                        <span [innerHTML]="getFormatDisplay(format)"></span>
                      </button>
                    }
                  </div>
                </div>
              </td>

              <td class="variants-cell variants-cell-actions">
                <div class="d-flex justify-content-center align-items-center">
                  <div
                    ngbDropdown
                    container="body"
                    placement="bottom bottom-right"
                    dropdownClass="edit-asset-modal-actions">
                    <button type="button" ngbDropdownToggle id="action-toggle" class="variants-action-toggle">
                      &#x22EE;
                    </button>
                    <div ngbDropdownMenu style="border: none !important; padding: 0 !important">
                      <button type="button" class="delete-btn" (click)="onDelete(asset, i)">Delete</button>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <button
    type="button"
    class="col tech-variant-btn p-0 d-flex align-items-center my-2 my-sm-3 variant-add-button"
    (click)="onAddVariant()">
    <div class="variant-add-button__circle">
      <i class="_500 fa fa-plus fa-lg variant-add-button__icon" aria-hidden="true"></i>
    </div>
    <span class="ms-2 f-10 _700 text-uppercase">ADD TECHNICAL VARIANT</span>
  </button>
</div>
